import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 update_promotion_message_setting: { message: "idle" },
};

export const update_promotion_message_setting_Slice = createSlice({
 name: "update_promotion_message_setting",
 initialState,
 reducers: {
  success_update_promotion_message_setting: (state, action) => {
   state.update_promotion_message_setting = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_update_promotion_message_setting: (state, action) => {
   state.update_promotion_message_setting = { status: app_consts.FAIL, message: action.payload };
  },
  reset_update_promotion_message_setting: (state) => {
   state.update_promotion_message_setting = { status: app_consts.IDLE };
  },
  loading_update_promotion_message_setting: (state) => {
   state.update_promotion_message_setting = { status: app_consts.LOADING };
  },
 }
});

export const { success_update_promotion_message_setting, fail_update_promotion_message_setting, reset_update_promotion_message_setting, loading_update_promotion_message_setting } = update_promotion_message_setting_Slice.actions;

export default update_promotion_message_setting_Slice.reducer;